function __parseResponse(response) {
  const m = Object.entries(response).map(([key, value]) => {
    try {
      return [key, JSON.parse(value)];
    } catch (error) {
      // JSONパースエラーの処理
      console.error(`Error parsing value for key "${key}":`, error);
      return [key, value]; // エラーの場合は元の値を返す
    }
  });
  return Object.fromEntries(m);
}

let ServerStorage = {
  apiBaseUrl: '/wp-json/fms/v1/server-storage',

  setValue: async function (key, value) {
    try {
      const response = await $.ajax({
        url: this.apiBaseUrl,
        method: 'PUT',
        data: {
          key: key,
          value: JSON.stringify(value)
        }
      });

      if (response.success) {
        return response;
      } else {
        throw new Error('Failed to set value. Error: ' + response.error);
      }
    } catch (error) {
      if (error.responseJSON && error.responseJSON.error) {
        throw new Error('Failed to set value. Error: ' + error.responseJSON.error);
      } else {
        throw new Error('Failed to set value. ' + error.statusText);
      }
    }
  },

  getValue: async function (key) {
    return (await ServerStorage.getValues([key]))[key];
  },

  getValues: async function (keys) {
    try {
      const response = await $.ajax({
        url: this.apiBaseUrl + '/get',
        method: 'POST',
        data: {
          keys: keys
        }
      });

      if (response.error) {
        throw new Error('Failed to get values. Error: ' + response.error);
      } else {
        return __parseResponse(response);
      }
    } catch (error) {
      if (error.responseJSON && error.responseJSON.error) {
        throw new Error('Failed to get values. Error: ' + error.responseJSON.error);
      } else {
        throw new Error('Failed to get values. ' + error.statusText);
      }
    }
  },

  deleteValue: async function (key) {
    return ServerStorage.deleteValues([key]);
  },
  
  deleteValues: async function (keys) {
    try {
      const response = await $.ajax({
        url: this.apiBaseUrl,
        method: 'DELETE',
        data: {
          keys: keys
        }
      });

      if (response.success) {
        return response;
      } else {
        throw new Error('Failed to delete values. Error: ' + response.error);
      }
    } catch (error) {
      if (error.responseJSON && error.responseJSON.error) {
        throw new Error('Failed to delete values. Error: ' + error.responseJSON.error);
      } else {
        throw new Error('Failed to delete values. ' + error.statusText);
      }
    }
  },

  getKeys: async function () {
    try {
      const response = await $.ajax({
        url: this.apiBaseUrl + '/keys',
        method: 'GET'
      });

      if (Array.isArray(response)) {
        return response;
      } else {
        throw new Error('Failed to get keys. Unexpected response format.');
      }
    } catch (error) {
      if (error.responseJSON && error.responseJSON.error) {
        throw new Error('Failed to get keys. Error: ' + error.responseJSON.error);
      } else {
        throw new Error('Failed to get keys. ' + error.statusText);
      }
    }
  }
}

export default ServerStorage;
